// extracted by mini-css-extract-plugin
export default {"commentsContainer":"Comments_commentsContainer__dTrhK","header":"Comments_header__tigxz"};